export const propTernary = (propName, yes, no) => (props) =>
  props[propName] ? yes : no;
